import React from "react";
import classnames from "classnames";
import AutorenewRoundedIcon from "@material-ui/icons/AutorenewRounded";
import { apiKeys } from "../../ActiveDrip/activeDripConfig";

import { ReactComponent as SendIcon } from "assets/vectors/send.svg";
import { ReactComponent as EmailIcon } from "assets/vectors/email3.svg";
import { ReactComponent as ClicksIcon } from "assets/vectors/clicks2.svg";
import { ReactComponent as DeleteEmailIcon } from "assets/vectors/email4.svg";
import HorizontalDotsIconButton from "common/Components/ActionDrawer/HorizontalDotsIconButton";
import { emailStatsVariant } from "./EmailDripItem.constants";
import { calculateRate } from "utils/mathUtils";

function MobileStats({ data, statsVariant = emailStatsVariant.DEFAULT }) {
  const totalEmailsSent = data[apiKeys.totalEmailsSent] || 0;
  const totalOpenCount = data[apiKeys.totalOpenCount] || 0;

  const totalClicksNumber = data[apiKeys.totalClicksNumber] || 0;
  const clickRate = calculateRate(totalClicksNumber, totalEmailsSent);

  const isOpaque = statsVariant === emailStatsVariant.WITH_WITH_OVERLAY;
  const isGreyedOut = statsVariant === emailStatsVariant.GREYED_OUT;
  const hasSentEmail = Boolean(totalEmailsSent);

  const iconClass = isGreyedOut
    ? "tw-text-[rgba(39,37,34,0.6)] tw-fill-[rgba(39,37,34,0.6)] [&_path]:tw-fill-[rgba(39,37,34,0.6)] [&_rect]:tw-fill-[#f2f2f2]"
    : "";

  return (
    <div
      className={classnames(
        "tw-grid tw-grid-cols-2 tw-gap-2 tw-p-3 tw-border-t tw-border-b-0 tw-border-r-0 tw-border-l-0 tw-border-solid tw-border-[#e7e6e4] max-[375px]:tw-gap-1 max-[375px]:tw-p-1",
        isOpaque && "tw-opacity-50"
      )}
    >
      <div
        className={classnames(
          "tw-flex tw-gap-3 tw-font-normal tw-text-[10px] tw-leading-[12px] tw-tracking-[0.04em] tw-rounded-[10px] tw-text-[rgba(0,0,0,0.4)] tw-bg-[#fbfbfb] tw-py-[10px] tw-pl-[10px] tw-pr-[3px]",
          isGreyedOut && "tw-text-[rgba(39,37,34,0.6)]"
        )}
      >
        <SendIcon className={iconClass} />

        <div>
          <div>SENDS</div>
          <div
            className={classnames(
              "tw-font-medium tw-text-[16px] tw-leading-[20px] tw-tracking-[0.02em] tw-mt-1.5",
              !isGreyedOut && "tw-text-[#493ab1]"
            )}
          >
            {totalEmailsSent}
          </div>
        </div>
      </div>

      <div
        className={classnames(
          "tw-flex tw-gap-3 tw-font-normal tw-text-[10px] tw-leading-[12px] tw-tracking-[0.04em] tw-rounded-[10px] tw-text-[rgba(0,0,0,0.4)] tw-bg-[#fbfbfb] tw-py-[10px] tw-pl-[10px] tw-pr-[3px]",
          isGreyedOut && "tw-text-[rgba(39,37,34,0.6)]"
        )}
      >
        <EmailIcon className={iconClass} />

        <div>
          <div>OPENED BY</div>
          <div
            className={classnames(
              "tw-font-medium tw-text-[16px] tw-leading-[20px] tw-tracking-[0.02em] tw-mt-1.5",
              !isGreyedOut && "tw-text-[#1dbe8a]"
            )}
          >
            {totalOpenCount}
          </div>
        </div>
      </div>

      <div
        className={classnames(
          "tw-flex tw-gap-3 tw-font-normal tw-text-[10px] tw-leading-[12px] tw-tracking-[0.04em] tw-rounded-[10px] tw-text-[rgba(0,0,0,0.4)] tw-bg-[#fbfbfb] tw-py-[10px] tw-pl-[10px] tw-pr-[3px]",
          isGreyedOut && "tw-text-[rgba(39,37,34,0.6)]"
        )}
      >
        <ClicksIcon className={iconClass} />

        <div>
          <div>CLICK RATE</div>

          <div
            className={classnames(
              "tw-font-medium tw-text-[16px] tw-leading-[20px] tw-tracking-[0.02em] tw-mt-1.5",
              !isGreyedOut && "tw-text-[#0052c9]"
            )}
          >
            {hasSentEmail ? (
              <span>
                {clickRate} %
                <span className="!tw-text-[12px] tw-ml-1">
                  ({totalClicksNumber} clicks)
                </span>
              </span>
            ) : (
              "-"
            )}
          </div>
        </div>
      </div>
      <div
        className={classnames(
          "tw-flex tw-gap-3 tw-font-normal tw-text-[10px] tw-leading-[12px] tw-tracking-[0.04em] tw-rounded-[10px] tw-text-[rgba(0,0,0,0.4)] tw-bg-[#fbfbfb] tw-py-[10px] tw-pl-[10px] tw-pr-[3px]",
          isGreyedOut && "tw-text-[rgba(39,37,34,0.6)]"
        )}
      >
        <DeleteEmailIcon className={iconClass} />

        <div>
          <div>UNSUBSCRIBED</div>
          <div
            className={classnames(
              "tw-font-medium tw-text-[16px] tw-leading-[20px] tw-tracking-[0.02em] tw-mt-1.5",
              !isGreyedOut && "tw-text-[#cc5c5c]"
            )}
          >
            {hasSentEmail ? data[apiKeys.unsubscribedCount] : "-"}
          </div>
        </div>
      </div>
    </div>
  );
}

function MobileEmailDripItem({
  data,
  fieldConfig,
  showStats,
  writeDisabled,
  handleEdit,
  onMobileActionsClick,
  HeaderIcon = AutorenewRoundedIcon,
  MobileActionIcon = HorizontalDotsIconButton,
  headerFormatter = () => null,
  statsVariant,
}) {
  return (
    <section className="tw-bg-white tw-border-[1.5px] tw-border-solid tw-border-[#dfdfdf] tw-rounded-[5px] tw-mb-5">
      <div className="tw-py-[10px] tw-px-2 tw-flex tw-items-center tw-gap-2 tw-w-[calc(100vw-32px)]">
        <HeaderIcon className="tw-text-[#d9d9d9]" />

        <div
          className={classnames(
            "ellipsis tw-grow tw-font-medium tw-text-[16px] tw-leading-[20px] tw-tracking-[0.04em] tw-underline tw-text-[#493ab1]",
            writeDisabled && "tw-opacity-50"
          )}
          onClick={() => {
            if (writeDisabled) return;
            handleEdit(data);
          }}
        >
          {headerFormatter(data)}
        </div>
        <div className="tw-shrink-0">
          <MobileActionIcon onClick={() => onMobileActionsClick(data)} />
        </div>
      </div>
      <div className="tw-px-3">
        {fieldConfig.map(
          ({ label, source, format, className, contentClassName }) => (
            <div
              className={classnames(
                "tw-border-t tw-border-b-0 tw-border-r-0 tw-border-l-0 tw-border-solid tw-border-[#e7e6e4] tw-font-normal tw-text-[14px] tw-leading-[18px] tw-tracking-[0.02em] tw-text-black tw-py-[10px] tw-flex tw-justify-between tw-items-start",
                className
              )}
              key={label}
            >
              <span className="tw-font-semibold tw-shrink-0">{label}: </span>
              <span className={classnames("tw-text-right", contentClassName)}>
                {(format ? format(data) : data[source]) || "-"}
              </span>
            </div>
          )
        )}
      </div>
      {showStats && <MobileStats data={data} statsVariant={statsVariant} />}
    </section>
  );
}

export default MobileEmailDripItem;
